import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import bgTranslation from './locales/bg/translation.json';
import enTranslation from './locales/en/translation.json';
import bgHomepage from './locales/bg/homepage.json';
import enHomepage from './locales/en/homepage.json';
import bgContact from './locales/bg/contact.json';
import enContact from './locales/en/contact.json';
import bgAbout from './locales/bg/about.json';
import enAbout from './locales/en/about.json';
import bgPortfolio from './locales/bg/portfolio.json';
import enPortfolio from './locales/en/portfolio.json';

const resources = {
  bg: {
    translation: bgTranslation,
    homepage: bgHomepage,
    contact: bgContact,
    about: bgAbout,
    portfolio: bgPortfolio
  },
  en: {
    translation: enTranslation,
    homepage: enHomepage,
    contact: enContact,
    about: enAbout,
    portfolio: enPortfolio
  }
};

// Get saved language or default to Bulgarian
const savedLanguage = localStorage.getItem('i18nextLng');
const defaultLanguage = (savedLanguage && (savedLanguage === 'bg' || savedLanguage === 'en')) ? savedLanguage : 'bg';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'bg',
    
    ns: ['translation', 'homepage', 'contact', 'about', 'portfolio'],
    defaultNS: 'translation',
    
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      checkWhitelist: true,
    },
    
    whitelist: ['bg', 'en'],
    
    interpolation: {
      escapeValue: false
    }
  });

// Ensure the detected/default language is saved to localStorage
if (!savedLanguage || (savedLanguage !== 'bg' && savedLanguage !== 'en')) {
  localStorage.setItem('i18nextLng', defaultLanguage);
}

export default i18n; 